var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 3C1.25 2.58579 1.58579 2.25 2 2.25H8C9.25978 2.25 10.468 2.75044 11.3588 3.64124C12.2496 4.53204 12.75 5.74022 12.75 7V21C12.75 21.4142 12.4142 21.75 12 21.75C11.5858 21.75 11.25 21.4142 11.25 21C11.25 20.4033 11.0129 19.831 10.591 19.409C10.169 18.9871 9.59674 18.75 9 18.75H2C1.58579 18.75 1.25 18.4142 1.25 18V3ZM11.25 18V7C11.25 6.13805 10.9076 5.3114 10.2981 4.7019C9.6886 4.09241 8.86195 3.75 8 3.75H2.75V17.25H9C9.81606 17.25 10.6047 17.516 11.25 18Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6412 3.64124C13.532 2.75044 14.7402 2.25 16 2.25H22C22.4142 2.25 22.75 2.58579 22.75 3V18C22.75 18.4142 22.4142 18.75 22 18.75H15C14.4033 18.75 13.831 18.9871 13.409 19.409C12.9871 19.831 12.75 20.4033 12.75 21C12.75 21.4142 12.4142 21.75 12 21.75C11.5858 21.75 11.25 21.4142 11.25 21V7C11.25 5.74022 11.7504 4.53204 12.6412 3.64124ZM12.75 18C13.3953 17.516 14.1839 17.25 15 17.25H21.25V3.75H16C15.138 3.75 14.3114 4.09241 13.7019 4.7019C13.0924 5.3114 12.75 6.13805 12.75 7V18Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/book-open.81faf6208d27a6af69e8c561919a1bb0.svg";
export { ForwardRef as ReactComponent };